import { jsx, jsxs } from 'react/jsx-runtime';
import Editor from '@monaco-editor/react';

function JsonEditor(props) {
  return /* @__PURE__ */ jsx("div", { className: "overflow-hidden rounded-md border-2 border-secondary", children: /* @__PURE__ */ jsx(
    Editor,
    {
      loading: /* @__PURE__ */ jsx(SkeletonEditorLoading, {}),
      theme: "vs-dark",
      height: "200px",
      language: "json",
      value: props.value,
      onChange: props.onChange
    }
  ) });
}
function SkeletonEditorLoading() {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "aria-label": "Loading Editor...",
      className: "h-[200px] w-full bg-secondary animate-pulse p-6 flex flex-col gap-y-1.5",
      children: [
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" }),
        /* @__PURE__ */ jsx("span", { className: "block bg-primary h-3 w-full animate-pulse rounded" })
      ]
    }
  );
}

export { JsonEditor };
